<template>
  <kst-section :title="Info.Section.LowStockReminder.Title">
    <kst-output field="LowStockEmailLastSent" :data="details" :catalog="Catalog"/>

    <List class="mt-5"
      :emailList="details.LowStockEmail"
    />
  </kst-section>
</template>

<script>
import Catalog from "../CpCatalog.js";
import Info from "../CpInfo.js";

import List from "./CpD_LowStockReminder_List.vue";

export default {
  components: {
    List
  },
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog,
    Info: Info
  })
}
</script>